// extracted by css-extract-rspack-plugin
export default {"drop":"drop--DkpabeOsD80vcEoa","wrapper":"wrapper--OYVBmjmk4XMRHum5"};